<template>
  <div class="home-activity-body">
    <div>
      <div class="home-title">
        <p>热门活动</p>
        <span @click="$router.push(`/homeActivity`)">查看更多 ></span>
      </div>
      <div class="home-activity-list">
        <div v-for="(el, index) in activityList" :key="index">
          <v-activity-status :activity-status="el.activityStatus" />
          <span>
            <images :id="el.cover ? el.cover.attachmentId : ''" />
          </span>
          <div>
            <p>地点：{{ el.activityPlace }}</p>
            <span>时间：{{ el.activityTime | moment("YYYY-MM-DD HH时") }}</span>
          </div>
          <p>
            <a-button @click="$router.push(`/homeActivity/detail?id=${el.id}`)"
              >查看详情</a-button
            >
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { getActivityList } from "@/api/activity";
import images from "@/page/components/image";
import VActivityStatus from "@/components/VActivityStatus";
export default {
  components: {
    VActivityStatus,
    images,
  },
  data() {
    return {
      activityList: [],
    };
  },
  methods: {
    loadData() {
      getActivityList({ current: 1, size: 4 }, {}).then((res) => {
        this.activityList = res.data.records;
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style lang="less" scoped>
.home-title {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 40px;

  > p {
    font-size: 24px;
    line-height: 24px;
    padding-left: 12px;
    border-left: 4px solid #1abc9c;
    font-weight: 400;
  }

  > span {
    line-height: 14px;
    color: #8c8c8c;
    cursor: pointer;
  }
}

.home-activity-body {
  background: #fff;
  padding: 40px 0;

  > div {
    width: 1200px;
    margin: 0 auto;

    .home-activity-list {
      display: flex;
      flex-wrap: wrap;

      > div {
        width: 282px;
        border: 1px solid #f0f0f0;
        border-radius: 4px;
        margin-right: 24px;
        position: relative;
        overflow: hidden;
        cursor: pointer;
        transition: all 0.3s;

        &:nth-child(4n) {
          margin-right: 0;
        }

        > img {
          position: absolute;
          top: 0;
          left: 0;
        }

        > span {
          height: 160px;
          display: block;

          > img {
            width: 100%;
            height: 100%;
            display: block;
          }
        }

        > div {
          padding: 16px;

          > p {
            line-height: 14px;
            margin-bottom: 12px;
          }

          > span {
            display: block;
            line-height: 14px;
          }
        }

        > p {
          display: none;
          padding: 16px;

          > button {
            display: block;
            width: 120px;
            height: 40px;
            background: #1abc9c;
            border-radius: 2px;
            color: #fff;
            border-color: #1abc9c;
            text-align: center;
            line-height: 40px;
            margin: 0 auto;
          }
        }

        &:hover {
          box-shadow: 0px 4px 16px 0px rgba(0, 0, 0, 0.08);

          > div {
            display: none;
          }

          > p {
            display: block;
          }
        }
      }
    }
  }
}
</style>
